// @flow
import React, { Fragment } from "react";
import buildColor from "@fdr/static-ui/ColorPalette";
import { Text, Label } from "./styled-components";

const defaultInfo = {
  defaultText: "Watch video",
  scrolledText: "Watch",
  tag: "live"
};

type Props = {
  isNightMode: boolean,
  isReplay: boolean,
  small: boolean
};

export const BuildButtonInfoForExperiment = ({
  isNightMode,
  isReplay,
  small
}: Props) => {
  const isScrolled = small;
  const buttonText = isScrolled
    ? defaultInfo.scrolledText
    : defaultInfo.defaultText;

  return (
    <Fragment>
      <Text
        customColor={isNightMode && isReplay && buildColor("white")}
        hasExperiment
      >
        {buttonText}
        <Label
          color={buildColor("white")}
          backgroundColor={buildColor("red")}
          scrolled={isScrolled}
        >
          {defaultInfo.tag}
        </Label>
      </Text>
    </Fragment>
  );
};
